import {ConfigKey} from '@nursio-link/common';

import {graphqlClient} from '@/services/graphqlClient';
import type {GetConfigByKeyQuery} from '@/services/graphqlHooks';
import {useGetConfigByKeyQuery} from '@/services/graphqlHooks';
import queryClient from '@/services/queryClient';

export const employeeWorkTimeTrackingConfigVariables = {
  key: ConfigKey.FORCE_EMPLOYEE_WORK_TIME_TRACKING,
};

export const isEmployeeWorkTimeTrackingForced = async () => {
  try {
    const configQuery = await queryClient.fetchQuery<GetConfigByKeyQuery>({
      queryKey: useGetConfigByKeyQuery.getKey(
        employeeWorkTimeTrackingConfigVariables
      ),
      queryFn: () =>
        graphqlClient.request(
          useGetConfigByKeyQuery.document,
          employeeWorkTimeTrackingConfigVariables
        ),
      staleTime: 30_000,
    });

    return configQuery.getConfigByKey?.value.boolValue === true;
  } catch {
    return false;
  }
};

export default isEmployeeWorkTimeTrackingForced;
